import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../../components/helpers/Translator';

export default function AccionaResidualImpactProbElement(props) {
  const {
    state,
    type,
    size = 16,
  } = props;

  return (
    <span
      title={`${
        type === 'imp' ? 'Impacto residual' : 'Probabilidad residual'
      } ${
        state !== null
          ? ReactDOMServer.renderToString(
              <Translator
                file="filter"
                name={`filter.probability.${Math.floor(state)}`}
              />
            )
          : ''
      }`}
    >
      <div className="text-center mb-2">
        <ImpactProbTitle className="pr-1">
          {type === 'imp' ? 'I: ' : 'P: '}
        </ImpactProbTitle>
        <ImpactProbValue>{state}</ImpactProbValue>
      </div>
    </span>
  );
}

const ImpactProbTitle = styled.span`
  font-size: 14px;
  font-weight: lighter;
`;
const ImpactProbValue = styled.span`
  font-size: 14px;
  font-weight: bold;
`;